export default {"src":"/_next/static/media/chemistry.120e5dc9.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};